import React, { Suspense } from "react";
import { lazy } from "@loadable/component";
import routes from "../../routes.json";
import LoadingPage from "../../components/layout/loading/page/loadingPage";
import { useGlobalContext } from "../../context/global/state";
import useFeatureFlag from "../../hooks/featureFlags/useFeatureFlag";

/*
	About
		- Adds all the components dynamically
		- The string `../../` changes directory to ./pages to get all component
		  - This cannot be a const (webpack issue)
*/

const useBuilderComponents = () => {
	const {
		data: { environment },
	} = useGlobalContext();
	const { feature } = useFeatureFlag();
	const managerEnabled = feature.get("280");

	const List: any = [];

	const notAllowed = (path) => {
		if (environment === "custom") return true;
		if (path.includes("customize/manager") && !managerEnabled) return true;
		return false;
	};

	routes
		.filter((route) => route.path.includes("customize"))
		.forEach((route) => {
			const suspenseProps = {
				fallback: <LoadingPage id="builder-loading" />,
			};

			const LazyComponent = lazy(
				() =>
					import(
						`../../${
							notAllowed(route.path)
								? "pages/page-not-found/index"
								: route.component
						}`
					) /*Fix(webpack): need starting string*/,
			);

			const component: React.FC = () => {
				return (
					<Suspense {...suspenseProps}>
						<LazyComponent />
					</Suspense>
				);
			};

			List.push({
				path: route.path,
				component,
			});
		});

	return List;
};

export default useBuilderComponents;
